import {
  SCHEDULE_MEETING_TYPES,
  SCHEDULE_MEETING_TYPE_COLORS,
  SCHEDULE_MEETING_TYPE_DESCRIPTIONS,
  SCHEDULE_MEETING_TYPE_ICONS,
  SCHEDULE_MEETING_TYPE_LABELS,
  type ScheduleMeetingType,
} from '../../lib/schedule/meetingTypes';

export type ScheduleType = ScheduleMeetingType;

// Legacy calendar utility compatibility shape (local-only calendar helpers).
export interface ScheduleSlot {
  id: string;
  date: string;
  time: string;
  type: ScheduleType;
  isActive: boolean;
  createdAt?: Date;
  updatedAt?: Date;
  metadata?: Record<string, unknown>;
}

export interface ScheduleTypeConfig {
  type: ScheduleType;
  label: string;
  icon: string;
  color: string;
  description: string;
}

export const SCHEDULE_TYPE_CONFIGS: Record<ScheduleType, ScheduleTypeConfig> =
  Object.fromEntries(
    SCHEDULE_MEETING_TYPES.map((type) => [
      type,
      {
        type,
        label: SCHEDULE_MEETING_TYPE_LABELS[type],
        icon: SCHEDULE_MEETING_TYPE_ICONS[type],
        color: SCHEDULE_MEETING_TYPE_COLORS[type],
        description: SCHEDULE_MEETING_TYPE_DESCRIPTIONS[type],
      },
    ]),
  ) as Record<ScheduleType, ScheduleTypeConfig>;

export const DEFAULT_TIME_SLOTS = [
  '9:00 AM',
  '9:30 AM',
  '10:00 AM',
  '10:30 AM',
  '11:00 AM',
  '11:30 AM',
  '12:00 PM',
  '12:30 PM',
  '1:00 PM',
  '1:30 PM',
  '2:00 PM',
  '2:30 PM',
  '3:00 PM',
  '3:30 PM',
  '4:00 PM',
  '4:30 PM',
];
